import { createSlice } from "@reduxjs/toolkit";

export const activeInterviewedTabSlice = createSlice({
    name:'activeInterviewedTab',
    initialState:{
        value:'',
    },
    reducers:{
        updateActiveInterviewedTab:(state, action)=>{
             state.value = action.payload;
           
        }
    }
})

export const selectActiveInterviewedTab = (state)=>state.activeInterviewedTab.value

export const { updateActiveInterviewedTab } = activeInterviewedTabSlice.actions

export default activeInterviewedTabSlice.reducer